export type UserLevel = 1 | 2 | 3 | 4 | 5 | 6;

export const MIN_USER_LEVEL: UserLevel = 1;
export const MAX_USER_LEVEL: UserLevel = 6;

export const LEVEL_LEAVES_REQUIREMENTS: Record<UserLevel, readonly [number, number | null]> = {
  1: [0, 3],
  2: [4, 6],
  3: [7, 11],
  4: [12, 16],
  5: [17, 20],
  6: [21, null]
};

export function clampUserLevel(level: number): UserLevel {
  if (!Number.isFinite(level)) {
    return MIN_USER_LEVEL;
  }

  const normalizedLevel = Math.floor(level);

  if (normalizedLevel <= MIN_USER_LEVEL) {
    return MIN_USER_LEVEL;
  }

  if (normalizedLevel >= MAX_USER_LEVEL) {
    return MAX_USER_LEVEL;
  }

  return normalizedLevel as UserLevel;
}

export function getUserLevelFromLeaves(leaves: number | null | undefined): UserLevel {
  const normalizedLeaves = Number.isFinite(leaves) ? Math.max(0, Math.floor(leaves as number)) : 0;

  for (let level = MAX_USER_LEVEL; level >= MIN_USER_LEVEL; level--) {
    if (normalizedLeaves >= LEVEL_LEAVES_REQUIREMENTS[level as UserLevel][0]) {
      return level as UserLevel;
    }
  }

  return MIN_USER_LEVEL;
}
